// extracted by mini-css-extract-plugin
export default {"container":"TemplateTwo_container__D9LA2","multiNode":"TemplateTwo_multiNode__3W3nL"};